export default __webpack_public_path__ + "static/blob1-d5fc1ed979d58be6177fce7719df3873.svg";